import axiosInstance from './api_helper';

const mouvementStockService = {
    // Lister tous les mouvements avec pagination
    list: async (params = {}) => {
        const queryParams = new URLSearchParams();
        
        if (params.page !== undefined) queryParams.append('page', params.page);
        if (params.size !== undefined) queryParams.append('size', params.size);
        if (params.sort) queryParams.append('sort', params.sort);
        
        const queryString = queryParams.toString();
        const url = queryString ? `/api/mouvements-stock?${queryString}` : '/api/mouvements-stock';
        
        const response = await axiosInstance.get(url);
        return response.data;
    },

    // Rechercher avec filtres
    search: async (params = {}) => {
        const queryParams = new URLSearchParams();
        
        // Pagination
        if (params.page !== undefined) queryParams.append('page', params.page);
        if (params.size !== undefined) queryParams.append('size', params.size);
        
        // Filtres
        if (params.search) queryParams.append('search', params.search);
        if (params.typeMouvement) queryParams.append('typeMouvement', params.typeMouvement);
        if (params.articleId) queryParams.append('articleId', params.articleId);
        if (params.numeroLot) queryParams.append('numeroLot', params.numeroLot);
        if (params.dateDebut) queryParams.append('dateDebut', params.dateDebut);
        if (params.dateFin) queryParams.append('dateFin', params.dateFin);
        if (params.utilisateur) queryParams.append('utilisateur', params.utilisateur);
        if (params.referenceDocument) queryParams.append('referenceDocument', params.referenceDocument);
        
        const queryString = queryParams.toString();
        const url = `/api/mouvements-stock/search?${queryString}`;
        
        const response = await axiosInstance.get(url);
        return response.data;
    },

    // Obtenir un mouvement par ID
    getById: async (id) => {
        const response = await axiosInstance.get(`/api/mouvements-stock/${id}`);
        return response.data;
    },

    // Obtenir les mouvements par article
    getByArticle: async (articleId, params = {}) => {
        const queryParams = new URLSearchParams();
        
        if (params.page !== undefined) queryParams.append('page', params.page);
        if (params.size !== undefined) queryParams.append('size', params.size);
        if (params.dateDebut) queryParams.append('dateDebut', params.dateDebut);
        if (params.dateFin) queryParams.append('dateFin', params.dateFin);
        
        const queryString = queryParams.toString();
        const url = queryString 
            ? `/api/mouvements-stock/article/${articleId}?${queryString}`
            : `/api/mouvements-stock/article/${articleId}`;
        
        const response = await axiosInstance.get(url);
        return response.data;
    },

    // Obtenir les mouvements par lot
    getByLot: async (numeroLot, params = {}) => {
        const queryParams = new URLSearchParams();
        
        if (params.page !== undefined) queryParams.append('page', params.page);
        if (params.size !== undefined) queryParams.append('size', params.size);
        
        const queryString = queryParams.toString();
        const url = queryString 
            ? `/api/mouvements-stock/lot/${numeroLot}?${queryString}`
            : `/api/mouvements-stock/lot/${numeroLot}`;
        
        const response = await axiosInstance.get(url);
        return response.data;
    },

    // Export Excel
    export: async (params = {}) => {
        const queryParams = new URLSearchParams();
        
        // Filtres pour l'export
        if (params.search) queryParams.append('search', params.search);
        if (params.typeMouvement) queryParams.append('typeMouvement', params.typeMouvement);
        if (params.articleId) queryParams.append('articleId', params.articleId);
        if (params.numeroLot) queryParams.append('numeroLot', params.numeroLot);
        if (params.dateDebut) queryParams.append('dateDebut', params.dateDebut);
        if (params.dateFin) queryParams.append('dateFin', params.dateFin);
        if (params.utilisateur) queryParams.append('utilisateur', params.utilisateur);
        if (params.referenceDocument) queryParams.append('referenceDocument', params.referenceDocument);
        
        const queryString = queryParams.toString();
        const url = `/api/mouvements-stock/export?${queryString}`;
        
                const response = await axiosInstance.get(url, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    },

    // Statistiques des mouvements
    getStatistics: async (params = {}) => {
        const queryParams = new URLSearchParams();
        
        if (params.dateDebut) queryParams.append('dateDebut', params.dateDebut);
        if (params.dateFin) queryParams.append('dateFin', params.dateFin);
        if (params.articleId) queryParams.append('articleId', params.articleId);
        
        const queryString = queryParams.toString();
        const url = queryString 
            ? `/api/mouvements-stock/statistics?${queryString}`
            : '/api/mouvements-stock/statistics';
        
        const response = await axiosInstance.get(url);
        return response.data;
    }
};

export default mouvementStockService;
